import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/product/ProductDetailClient.tsx");
